/* eslint no-underscore-dangle: ["error", { "allowAfterThis": true, "allow": ["__insp"] }] */
define('AwaLabs.Inspectlet.InstallScript', [
    'jQuery',
    'underscore',
    'Profile.Model',
    'AwaLabs.Inspectlet.Configuration'
], function InspectletInstallScript(
    jQuery,
    _,
    ProfileModel,
    InspectletConfiguration
) {
    'use strict';

    return {
        inspectletPromise: null,

        install: function install(layout) {
            var self = this;
            this.inspectletPromise = this.inspectletPromise || jQuery.Deferred();
            jQuery.when(
                ProfileModel.getPromise(),
                this.inspectletPromise
            ).done(function onPromiseDone() {
                var profile = ProfileModel.getInstance();
                profile.on('change:internalid', function onChange() {
                    if (!_.isUndefined(window.__insp) && profile.get('internalid') && profile.get('internalid') !== '') {
                        window.__insp.push(['identify', profile.get('internalid')]);
                    }
                });
            });
            layout.once('afterAppendView', function onAfterAppendView() {
                var run = function runInspectletInstall() {
                    self.executeScript();
                };
                if (typeof document !== 'undefined' && document.readyState === 'complete') {
                    if (typeof window !== 'undefined' && window.setTimeout) {
                        window.setTimeout(run, 0);
                    } else {
                        run();
                    }
                } else if (typeof window !== 'undefined' && window.addEventListener) {
                    window.addEventListener('load', function onWindowLoad() {
                        if (window.setTimeout) {
                            window.setTimeout(run, 0);
                        } else {
                            run();
                        }
                    }, false);
                } else {
                    run();
                }
            });
        },

        executeScript: function executeScript() {
            var self = this;
            var isAbLoaderEnabled = InspectletConfiguration.isAbLoaderEnabled();
            var websiteId = InspectletConfiguration.getWebsiteId();
            /* eslint-disable */
            (function () {
                var insp_ab_loader = isAbLoaderEnabled; // set this boolean to false to disable the A/B testing loader
                window.__insp = window.__insp || [];
                __insp.push(['wid', websiteId]);
                var ldinsp = function () {
                    if (typeof window.__inspld !== 'undefined') return;
                    window.__inspld = 1;
                    var insp = document.createElement('script');
                    insp.type = 'text/javascript';
                    insp.async = true;
                    insp.id = 'inspsync';
                    insp.src = (document.location.protocol == 'https:' ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=654437449&r=' + Math.floor(new Date().getTime() / 3600000);
                    var x = document.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(insp, x);
                    if (typeof insp_ab_loader !== 'undefined' && insp_ab_loader) {
                        var adlt = function () {
                            var e = document.getElementById('insp_abl');
                            if (e) {
                                e.parentNode.removeChild(e);
                                __insp.push(['ab_timeout']);
                            }
                        };
                        var adlc = 'body{ visibility: hidden !important; }';
                        var adln = typeof insp_ab_loader_t !== 'undefined' ? insp_ab_loader_t : 1200;
                        insp.onerror = adlt;
                        var abti = setTimeout(adlt, adln);
                        window.__insp_abt = abti;
                        var abl = document.createElement('style');
                        abl.id = 'insp_abl';
                        abl.type = 'text/css';
                        if (abl.styleSheet) abl.styleSheet.cssText = adlc; else abl.appendChild(document.createTextNode(adlc));
                        document.head.appendChild(abl);
                    }
                    self.inspectletPromise.resolve();
                };
                setTimeout(ldinsp, 0);
            }());
            /* eslint-enable */
        }
    };
});
